import { defineComponent as _defineComponent } from 'vue'
import Price from 'JS/components/price/Price.vue';
import ReviewStars from 'JS/components/ReviewStarsNew.vue';

import { DxpProductCarouselProduct } from 'JS/dxp/types/widgets/shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'DxpCarouselProductCard',
  props: {
    product: null
  },
  emits: ["product-click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'product-click'): void;
}), expose: any, slots: any, attrs: any }) {






return { __sfc: true,emit, Price, ReviewStars }
}

})